module.exports = {
  QUERIES_DIRECT: 2,
  QUERIES_INDIRECT: 3,
  QUERIES_CHAIN: 4,
  VIEWS_MAPS: 5,
  VIEWS_SEARCH: 6,
  ACTIONS_WEBSITE: 7,
  ACTIONS_PHONE: 8,
  ACTIONS_DRIVING_DIRECTIONS: 9,
  PHOTOS_VIEWS_MERCHANT: 10,
  PHOTOS_VIEWS_CUSTOMERS: 11,
  PHOTOS_COUNT_MERCHANT: 12,
  PHOTOS_COUNT_CUSTOMERS: 13,
  LOCAL_POST_VIEWS_SEARCH: 14,
  LOCAL_POST_ACTIONS_CALL_TO_ACTION: 15
};
